import {
  NotificationsMarkAsClickedInboxNotificationDocument,
  NotificationsMarkAsClickedInboxNotificationMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useNotificationMarkAsClicked = () => {
  const [mutate, { loading }] = useMutation(NotificationsMarkAsClickedInboxNotificationDocument, {
    extractorFn: (data: NotificationsMarkAsClickedInboxNotificationMutation) =>
      data.notificationsMutations.markAsClickedNotificationsInboxNotification,
  })

  return {
    updating: loading,
    async markAsClicked(id: number) {
      return mutate({ variables: { id } })
    },
  }
}
